<template>
  <div>
       <ad-header v-on:passNotifications="passNotifications" class="d-print-none" />
<!--       <v-content>-->
         <v-container fluid>
            <div class='center-container'>
               <router-view :notifications="notifications"/>
            </div>
         </v-container>
<!--      </v-content>-->
   </div>
</template>

<script>
import Header from "@/components/layout/Header";
export default {
   name: "ad-home",
   components: {
      "ad-header": Header
   },
   computed: {
     direction: function() {
       return this.$store.state.direction;
     }
  },
   data(){
      return {
         notifications:[]
      }
   },
   methods:{
      passNotifications(notifications) {
         this.notifications = notifications
      }
   }
};
</script>
